import { FC, useEffect, useMemo, type JSX } from 'react';
import { useHistory } from 'react-router';

import { ScheduledEvent } from '@payaca/types/scheduledEventsTypes';

import { groupScheduledEventsByDate } from '@payaca/helpers/scheduledEventsHelper';
import UntitledIcon from '@payaca/untitled-icons';

import Button from '@payaca/components/button/Button';
import { HeaderTagType } from '@payaca/components/headerTag/HeaderTag';
import MiniLoader from '@payaca/components/miniLoader/MiniLoader';
import GroupedScheduledEventsList from '../groupedScheduledEventsList/GroupedScheduledEventsList';
import UpcomingScheduledEvent from './UpcomingScheduledEvent';

import './UpcomingScheduledEventsList.sass';

type Props = {
  scheduledEvents: any[];
  getScheduledEvents: () => void;
  isGettingScheduledEvents: boolean;
  showLocation?: boolean;
};
const UpcomingScheduledEventsList: FC<Props> = ({
  scheduledEvents,
  getScheduledEvents,
  isGettingScheduledEvents,
  showLocation,
}: Props): JSX.Element => {
  const history = useHistory();
  const groupedScheduledEvents = useMemo(() => {
    return groupScheduledEventsByDate(scheduledEvents);
  }, [scheduledEvents]);

  useEffect(() => {
    getScheduledEvents();
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'getScheduledEvents'
  }, []);

  return (
    <div className="upcoming-scheduled-events-list">
      {isGettingScheduledEvents && !scheduledEvents?.length && (
        <div className="loader-container">
          <MiniLoader />
        </div>
      )}
      {!scheduledEvents?.length && !isGettingScheduledEvents && (
        <div className="empty-state-container">
          <div className="calendar-icon-container">
            <UntitledIcon name="calendar" className="w-10 h-10" />
          </div>
          <h2>No upcoming Events</h2>
          <p>You can add Events via your Schedule</p>
          <Button onClick={() => history.push('/schedule')}>Schedule</Button>
        </div>
      )}
      {!!scheduledEvents?.length && (
        <>
          <div
            className="calendar-link"
            onClick={() => history.push('/schedule')}
          >
            <UntitledIcon name="calendar" />
          </div>
          {groupedScheduledEvents && (
            <GroupedScheduledEventsList
              groupHeaderTagType={HeaderTagType.H2}
              groupedScheduledEvents={groupedScheduledEvents}
              renderScheduledEvent={(scheduledEvent: ScheduledEvent) => {
                return (
                  <UpcomingScheduledEvent
                    scheduledEvent={scheduledEvent}
                    onScheduledEventUpdateSuccess={getScheduledEvents}
                    showLocation={showLocation}
                  />
                );
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default UpcomingScheduledEventsList;
